/**
 * Mobile menu toggle
 * Safe for pages with and without animation
 */

const BODY_CLASS_MENU_OPEN = 'menu-open';
const MENU_CLASS_ACTIVE = 'active';

function getMobileMenuElements() {

	const header = document.querySelector('body > header');

	if (!header) {
		return {};
	}

	return {
		mobileToggle: header.querySelector('.mobile-toggle'),
		menu: header.querySelector('.menu'),
		menuLinks: header.querySelectorAll('.menu a'),
	};
}

function toggleBodyMenuState(active) {
	document.body.classList.toggle(BODY_CLASS_MENU_OPEN, active);
}

function openMenu(mobileToggle, menu) {

	if (!mobileToggle || !menu) {
		return;
	}

	mobileToggle.classList.add(MENU_CLASS_ACTIVE);
	menu.classList.add(MENU_CLASS_ACTIVE);
	mobileToggle.setAttribute('aria-expanded', 'true');

	toggleBodyMenuState(true);
}

function closeMenu(mobileToggle, menu) {

	if (!mobileToggle || !menu) {
		return;
	}

	mobileToggle.classList.remove(MENU_CLASS_ACTIVE);
	menu.classList.remove(MENU_CLASS_ACTIVE);
	mobileToggle.setAttribute('aria-expanded', 'false');

	toggleBodyMenuState(false);
}

function toggleMenu(mobileToggle, menu) {

	if (!mobileToggle || !menu) {
		return;
	}

	const isActive = mobileToggle.classList.contains(MENU_CLASS_ACTIVE);

	if (isActive) {
		closeMenu(mobileToggle, menu);
	} else {
		openMenu(mobileToggle, menu);
	}
}

export default function initMobileMenu() {

	const {
		mobileToggle,
		menu,
		menuLinks,
	} = getMobileMenuElements();

	if (!mobileToggle || !menu) {
		return;
	}

	mobileToggle.addEventListener('click', function () {
		toggleMenu(mobileToggle, menu);
	});

	menuLinks.forEach(function (link) {

		link.addEventListener('click', function () {
			closeMenu(mobileToggle, menu);
		});

	});

}
